import React, { useEffect, useState } from "react";
import Box from "./Box";

const CalendarDetail = (props) => {

    const [list, setList] = useState(props.list)

    useEffect(() => {
        setList(props.list)
    }, [props])

    return (
        <div className="NewStrategyModalOverlay">
            <div className="CalendarDetailModal">
                <div className={ "w-full flex justify-between" }>
                    <div className={ "NewStrategy" }>
                        <img alt={ "Logo" } src={ "/media/icons/calendar.svg" }
                             className={ "w-[18px] h-[18px]" }/>
                        Date Details
                    </div>
                    <button className={ "CloseIconButton" } onClick={ props.close }>
                        <img alt={ "Logo" } src={ "/media/icons/closeIcon.svg" } className={ "w-5 h-5" }/>
                    </button>
                </div>
                <div className={ "flex flex-col gap-4 w-full max-h-[770px] overflow-y-scroll" }>
                    <div className={ "HorizontalDivider" }></div>
                    <div className={ "py-4" }>
                        <div className={ "flex gap-[9px] w-full" }>
                            <div className={ "CalendarListDayContainer" }>
                                <div className={ "CalendarListDate" }>{ props.date.toLocaleString("default", {
                                    month: "short",
                                }) } { props.day }</div>
                                <div
                                    className={ "CalendarListDay" }>{ new Intl.DateTimeFormat("en-US", {weekday: "long"}).format(new Date(props.date?.getFullYear(), props.date?.getMonth(), props.day)) }</div>
                            </div>
                            <div className={ "flex flex-col w-full gap-3" }>
                                { list?.map((item) =>
                                    <Box item={ item } handleRevenue={ props.handleRevenue }
                                         handleSchedulePopup={ props.handleSchedulePopup }
                                         handleDeleteSchedule={ props.handleDeleteSchedule }
                                         handleCancelSchedule={ props.handleCancelSchedule }
                                         date={ new Date(props.date?.getFullYear(), props.date?.getMonth(), props.day) }
                                         day={ props.day }></Box>
                                ) }
                            </div>
                        </div>
                    </div>
                    <div className={ "HorizontalDivider" }></div>
                </div>
                <div className="flex justify-end w-full">
                    <button type="button" onClick={ props.close } className="CloseButton">
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CalendarDetail;